<template>
    <b-container>
      <b-row>
        <div class="py-5 text-center" v-loading="loading">
            <div v-html="data.content"></div>
        </div>
      </b-row>
    </b-container>
</template>

<script>
  export default{
    name: 'Page',
    data(){
      return{
        slug: this.$route.params.slug,
        loading: false,
        data:{}
      }
    },
    created(){
      this.fetch();
    },
    methods:{
      fetch(){
        this.loading = true;
        axios.get('/page/' + this.slug + '/detail?true')
        .then((response) => {
            this.data = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
    }
  }
</script>